import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";
import { getSelectedCompanyIds } from "../utils/workspaceStorage";

export const useDeliveryMethods = (page = 1, limit = 10, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["deliveryMethods", page, limit, search],
    () =>
      fetchData(
        `/delivery-methods?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
      ),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        deliveryMethods: response.data || [],
        pagination: response.pagination || { total: 0, page, limit },
      }),
    }
  );

  const updateMutation = useMutation(
    (method) => {
      // Garante id_projeto ao criar (um único projeto)
      const isCreate = !method?.id;
      const payload = { ...method };
      if (isCreate && (payload.id_projeto === undefined || payload.id_projeto === null)) {
        const ids = getSelectedCompanyIds();
        payload.id_projeto = ids.length ? ids[0] : null;
      }
      // evita mandar ids_projetos no body (não é aceito pelo backend de create/update)
      if ("ids_projetos" in payload) delete payload.ids_projetos;

      const endpoint = payload.id ? `/delivery-methods/${payload.id}` : `/delivery-methods`;
      const methodType = payload.id ? "PUT" : "POST";
      return fetchData(endpoint, methodType, payload);
    },
    { onSuccess: () => queryClient.invalidateQueries("deliveryMethods") }
  );

  // PUT parcial de status
  const updateStatusMutation = useMutation(
    ({ id, status }) => fetchData(`/delivery-methods/${id}`, "PUT", { status }),
    { onSuccess: () => queryClient.invalidateQueries("deliveryMethods") }
  );

  const deleteMutation = useMutation((id) => fetchData(`/delivery-methods/${id}`, "DELETE"), {
    onSuccess: () => queryClient.invalidateQueries("deliveryMethods"),
  });

  return { ...query, updateMutation, updateStatusMutation, deleteMutation };
};
